<template>
  <div class style="height:500px;">
    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >全选</el-checkbox>
    <div style="margin: 15px 0;"></div>

    <div>
      <div v-for="(item,index) in cities" :key="index" style="margin-top:30px;">
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox
            :indeterminate="item.isCheck"
            :label="item.area"
            :key="item.area"
          >{{item.area}}</el-checkbox>
          <div
            style="display:inline-block;margin-left:20px;"
            v-for="(itemA,indexA) in item.sysAreaMessageResultDTO"
            :key="indexA"
          >
            <el-checkbox-group
              v-model="checkedCities"
              @change="(val)=>{return proviceChange(val,index) }"
            >
              <el-checkbox :label="itemA.provice" :key="itemA.provice"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { querySysAreaMessage } from "@/api/public";
const cityOptions = [];
export default {
  name: "testVue",
  data() {
    return {
      checkAll: false,
      label1: [],
      checkedCities: ["东北"],
      cities: [],
      vmList: [],
      isIndeterminate: false
    };
  },
  created() {
    this._querySysAreaMessage();
  },
  methods: {
    _querySysAreaMessage() {
      querySysAreaMessage({}).then(res => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            item.isCheckAll = false;
            item.isCheck = false;
            this.label1.push(item.area);
            // console.log(item, index);
            res.data[index].sysAreaMessageResultDTO.forEach((itemA, indexA) => {
              item.isCheckAll = false;
              itemA.isCheck = false;
            });
          });
          this.cities = res.data;
          this.vmList = res.data;
        }
      });
      this.checkedCities = ["其他"];
      this.isIndeterminate = this.checkedCities.length > 0;
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.label1 : [];
      this.isIndeterminate = false;
    },
    proviceChange(val, index) {
      //   console.log(val, index);
      //   console.log(this.cities[index].sysAreaMessageResultDTO.length);
      if (val.length == this.cities[index].sysAreaMessageResultDTO.length) {
        this.isIndeterminate = false;
      }
    },
    handleCheckedCitiesChange(value) {
      // console.log(value)
      // console.log(this.label1)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
      // console.log(this.checkAll, this.isIndeterminate);
    }
  }
};
</script>

<style scoped>
</style>